<template>
  <div class="popup_overlay px-4">
    <div
      class="custom_dialog rounded-xl"
      id="checklistdialog"
      style="width: 600px; max-height: 85%; overflow: auto"
    >
      <div class="relative bg-white">
        <div class="bg-primary flex justify-between p-3 sticky top-0">
          <div v-if="!isAddNew" class="font-medium text-white heading-3">Select Checklist</div>
          <div v-else class="font-medium text-white heading-3">Add Custom Item</div>
          <div
            v-if="!isAddNew"
            @click="addNewShow"
            class="cursor-pointer font-medium text-white heading-3"
          >
            + Add Custom
          </div>
        </div>

        <div v-if="!isAddNew" style="white-space: nowrap" class="mb-4 mt-2">
          <div v-if="availableChecklists.length === 0" class="text-center text-text2 py-4 px-3">
            No checklist items found. <span class="text-primary cursor-pointer" @click="openSettings">Add in Settings</span>
          </div>
          <div
            v-for="(item, index) in availableChecklists"
            :key="`checklist-${index}-${item.selected}`"
            class="cust_card mx-2 heading-3 border-b border-gray1 bg-white text-sm px-3 py-3 items-center hover:bg-gray1 cursor-pointer"
            @click="toggleSelection(index)"
          >
            <div class="flex items-center gap-3">
              <span class="flex items-center justify-center" style="width: 20px;">
                <i v-if="item.selected" class="fas fa-check-circle text-primary"></i>
                <i v-else class="fa-regular fa-circle text-gray-400"></i>
              </span>
              <p class="text-gray4 heading-5" style="font-weight: bold">
                {{ item.checkListTitle }}
              </p>
            </div>
          </div>
          <div class="bg-white w-full flex justify-end pr-3 pt-3">
            <div class="text-rigth flex gap-2 mb-3">
              <Button
                :btnSize="'medium'"
                :textColor="'text1'"
                :btnColor="'gray1'"
                :btnText="'Cancel'"
                @buttonAction="discard()"
              />
              <Button
                :btnSize="'medium'"
                :textColor="'white'"
                :btnColor="'success'"
                :btnText="'Add'"
                @buttonAction="saveChecklist()"
              />
            </div>
          </div>
        </div>

        <AddCustomChecklistItem v-if="isAddNew" @handelAddNewChecklist="handelAddNewChecklist" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/View/components/globalButton.vue";
import AddCustomChecklistItem from "./AddCustomChecklistItem.vue";
import MyJobApp from "@/api/MyJobApp.js";

export default {
  props: ["checklist"],
  components: {
    Button,
    AddCustomChecklistItem,
  },
  data() {
    return {
      availableChecklists: [],
      isAddNew: false,
      filterObject: {
        start: 0,
        length: 100,
        sortOrder: 'DESC',
        isActive: true,
        sortBy: ''
      },
    };
  },
  mounted() {
    document.body.style = "overflow: hidden;";
    this.loadAvailableChecklists();
  },
  methods: {
    toggleSelection(index) {
      this.availableChecklists[index].selected = !this.availableChecklists[index].selected;
      this.$forceUpdate();
    },
    loadAvailableChecklists() {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})

      MyJobApp.GetCheckListItemList(
        this.filterObject.start,
        this.filterObject.length,
        '',
        this.filterObject.sortBy,
        this.filterObject.sortOrder,
        this.filterObject.isActive,
        0,
        response => {
          let tempList = response.Data.tableRow !== null ? response.Data.tableRow : []

          // Map to match expected structure and mark previously selected items
          this.availableChecklists = tempList.map(item => {
            const isSelected = this.checklist && this.checklist.some(
              selected => selected.checkListItemMasterId === item.checkListItemMasterId
            );

            return {
              ...item,
              selected: isSelected,
              checkLiTitle: item.checkListTitle // Map checkListTitle to checkLiTitle for consistency
            };
          });

          this.$store.dispatch('SetLoader', {status: false, message: ''})
        },
        () => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        }
      )
    },
    addNewShow() {
      this.isAddNew = true;
    },
    discard() {
      document.body.style = "overflow: visible;";
      this.$emit("checklistHandler", null);
    },
    openSettings() {
      this.$router.push({ path: '/setting', query: { activeTab: 3 } });
      this.discard();
    },
    saveChecklist() {
      let data = []
      this.availableChecklists.forEach(element => {
        if (element.selected) {
          data.push({
            checkListItemMasterId: element.checkListItemMasterId,
            checkListTitle: element.checkListTitle,
            checkLiTitle: element.checkListTitle,
            categoryName: element.categoryName || '',
            isActive: element.isActive
          })
        }
      });

      document.body.style = "overflow: visible;";
      this.$emit('checklistHandler', data)
    },
    handelAddNewChecklist(newChecklist) {
      this.isAddNew = false;
      if (newChecklist !== null) {
        this.availableChecklists.push({
          ...newChecklist,
          selected: true
        });
      }
    },
  },
  beforeDestroy() {
    document.body.style = "overflow: visible;";
  },
};
</script>

<style scoped>
.bg-primary-light {
  background-color: #e8f4fd;
}
</style>
